import { Injectable } from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  httpOptions,
  AssetSettlementRemoveApplicationAssetFn,
  AssetSettlementSearchAssetsFn,
  AssetSettlementSubmitPpsrFn,
  AssetSettlementGetApplicationPpsrInfoFn,
  AssetSettlementGetPpsrDetailsFn, AssetSettlementUpdatePpsrDetailFn,
} from '@portal-workspace/grow-ui-library';
import {
  ApplicationNotes,
  AssetSearchBody, AssetSettlementGetApplicationAssetFn, CreateApplicationAuditLog, CreateApplicationNoteBody, CreateApplicationNoteFn,
  PaginablePayloadApiResponse,
  parseJSON,
  PartialOrNull,
  PpsrAsset,
  PpsrData,
  PpsrDataRaw,
  PpsrDocument,
  SaveSupplierData,
  SaveSupplierResult,
  SearchGrantorsResult,
  SendAssetToSfData,
  SendAssetToSFResult,
  UpdateApplicationNoteBody,
  UpdateApplicationNoteFn,
} from '@portal-workspace/grow-shared-library';
import { map } from 'rxjs/operators';
import { ApiResponse, PayloadApiResponse } from '@portal-workspace/grow-shared-library';
import {AssetSupplier, VehicleDetails} from '@portal-workspace/grow-shared-library';
import {GetNotesByApplicationIdFn} from '@portal-workspace/grow-ui-library';

const URL_GET_PPSR_DETAILS = (applicationId: number) => `${environment.api2Host}/api2/get-ppsr-response/${applicationId}`; // get
const URL_GET_APPLICATION_ASSET = (applicationId: number) => `${environment.api2Host}/api2/get-application-assets/${applicationId}`; // get
const URL_GET_PPSR_DOCS = (applicationId: number) => `${environment.api2Host}/api2/get-PPSR-Document/${applicationId}`; //get
const URL_SEARCH_ASSET_SUPPLIER_BY_ABN_ACN = (abn: string) => `${environment.api2Host}/api2/search-supplier-by-abn-acn/${abn}`; // post
const URL_SEARCH_ASSET = (applicationId: number) => `${environment.api2Host}/api2/searchAssets/${applicationId}`; // post
const URL_SEARCH_GRANTORS = (applicationId: number) => `${environment.api2Host}/api2/searchGrantors/${applicationId}`; // post

const URL_SAVE_SUPPLIER  = () => `${environment.api2Host}/api2/add-supplier-sf`;
const URL_UPDATE_PPSR_DETAIL = () => `${environment.api2Host}/api2/update-ppsr-detail`; // post
const URL_ADD_PPSR_DETAIL = () => `${environment.api2Host}/api2/add-ppsr-data`;  // post
const URL_REMOVE_ASSET = (assetId: number) => `${environment.api2Host}/api2/remove-application-assets/${assetId}`; // post
const URL_UPDATE_ASSET = () => `${environment.api2Host}/api2/update-app-asset`; // post
const URL_SEND_ASSET_TO_SF = () => `${environment.api2Host}/api2/send-asset-to-sf`;  // post`
const URL_SUBMIT_PPSR = (applicationId: number) => `${environment.api2Host}/api2/submit-ppsr/${applicationId}`; // post
const URL_ADD_ASSET = () => `${environment.api2Host}/api2/add-app-asset`; // post

const URL_GET_NOTES_BY_APPLICATIONID = (applicationId: number,limit: number = 20, offset: number = 0, creditNotesOnly: boolean = false) => `${environment.api2Host}/api2/notes/${applicationId}?limit=${limit}&offset=${offset}&creditNotesOnly=${creditNotesOnly}`;   // get
const URL_CREATE_NOTE = () => `${environment.api2Host}/api2/add-app-notes`;//post
const URL_ADD_AUDIT_LOG = () => `${environment.api2Host}/api2/add-app-audit-logs`;//post
const URL_REMOVE_NOTE_BY_NOTESID = (notesId: number) => `${environment.api2Host}/api2/remove-notes/${notesId}`
const URL_UPDATE_NOTE = () => `${environment.api2Host}/api2/update-application-note`;//post


@Injectable()
export class PpsrService {

  constructor(private httpClient: HttpClient) {
  }

  createNote(data: CreateApplicationNoteBody): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_CREATE_NOTE(), data, httpOptions());
  }

  createNoteFn: CreateApplicationNoteFn = (data: CreateApplicationNoteBody): Observable<ApiResponse> => {
    return this.createNote(data);
  }

  removeApplicationNoteByNoteId(noteId: number): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_REMOVE_NOTE_BY_NOTESID(noteId), {}, httpOptions())
  }

  removeApplicationNoteByNoteIdFn = (noteId: number): Observable<ApiResponse> => {
    return this.removeApplicationNoteByNoteId(noteId)
  }

  updateApplicationNote(data: UpdateApplicationNoteBody): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_NOTE(), data, httpOptions())
  }

  updateApplicationNoteFn: UpdateApplicationNoteFn = (data: UpdateApplicationNoteBody): Observable<ApiResponse> => {
    return this.updateApplicationNote(data);
  }

  addAuditLog(data: CreateApplicationAuditLog ) {
    return this.httpClient.post<CreateApplicationAuditLog>(URL_ADD_AUDIT_LOG(), {
      ...data
    }, httpOptions()).pipe(
      map((r) => {
        return {
          status: true, message: '',
          payload: r
        }
      })
    );
  }

  addAuditLogFn = (data: CreateApplicationAuditLog): Observable<CreateApplicationAuditLog> => {
    return this.addAuditLog(data).pipe(map(r => r.payload));
  }

  getNotesByApplicationId(limit: number, offset: number, applicationId: number, creditNotesOnly: boolean = false): Observable<PaginablePayloadApiResponse<ApplicationNotes>> {
    return this.httpClient.get<PaginablePayloadApiResponse<ApplicationNotes>>(URL_GET_NOTES_BY_APPLICATIONID(applicationId, limit, offset, creditNotesOnly), httpOptions()).pipe();
  }

  getNotesByApplicationIdFn: GetNotesByApplicationIdFn = (limit: number, offset: number, applicationId: number, creditNotesOnly: boolean = false): Observable<PaginablePayloadApiResponse<ApplicationNotes>> => {
    return this.getNotesByApplicationId(limit, offset, applicationId, creditNotesOnly);
  }

  getApplicationPpsrInfoFn: AssetSettlementGetApplicationPpsrInfoFn = (applicationId: number) => {
    return combineLatest([
      this.getPpsrDetails(applicationId).pipe(map(r => r?.payload)),
      this.getApplicationAsset(applicationId).pipe(map(r => r?.payload)),
      this.getPpsrDocuments(applicationId).pipe(map(r => r?.payload)),
    ]);
  }



  addPpsrDetailFn = (data: PpsrDataRaw): Observable<number> => {
    return this.addPpsrDetail(data).pipe(map(r => r.payload));
  }
  addPpsrDetail(data: PpsrDataRaw): Observable<PayloadApiResponse<number>> {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_ADD_PPSR_DETAIL(), {
        ...data
      }, httpOptions()).pipe();
  }


  updatePpsrDetailFn: AssetSettlementUpdatePpsrDetailFn = (data: PpsrDataRaw): Observable<ApiResponse> => {
    return this.updatePpsrDetail(data).pipe();
  }
  updatePpsrDetail(data: PpsrDataRaw): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_PPSR_DETAIL(), {
      ...data
    }, httpOptions()).pipe();
  }

  searchAssetsFn: AssetSettlementSearchAssetsFn = (applicationId: number, data: { SearchNumber: string|undefined, NumberType: string|undefined}) => {
    return this.searchAssets(applicationId, data).pipe(map(r => r.payload));
  }
  searchAssets(applicationId: number, data:{
    SearchNumber: string|undefined,
    NumberType: string|undefined,
  }): Observable<PayloadApiResponse<VehicleDetails | {Error: any} | null>> {
    return this.httpClient.post<PayloadApiResponse<VehicleDetails | {Error: any} | null>>(URL_SEARCH_ASSET(applicationId), {
         SearchNumber: data.SearchNumber,
         NumberType: data.NumberType,
         SearchType: 'R',
       }, httpOptions()).pipe();
  }

  sendAssetToSfFn = (sfData: SendAssetToSfData): Observable<PayloadApiResponse<SendAssetToSFResult[]>> => {
    return this.sendAssetToSf(sfData).pipe();
  }
  sendAssetToSf(sfData: SendAssetToSfData): Observable<PayloadApiResponse<SendAssetToSFResult[]>> {
    return this.httpClient.post<PayloadApiResponse<SendAssetToSFResult[]>>(URL_SEND_ASSET_TO_SF(), sfData
      , httpOptions()).pipe();
  }

  submitPpsrFn: AssetSettlementSubmitPpsrFn = (applicationId: number): Observable<ApiResponse> => {
    return this.submitPpsr(applicationId);
  }
  submitPpsr(applicationId: number): Observable<ApiResponse> {
    return this.httpClient.post<any>(URL_SUBMIT_PPSR(applicationId),{}, httpOptions()).pipe();
  }

  searchSupplierFn = (abn: string, accreditedOnly = false): Observable<AssetSupplier[]> => {
    return this.searchSupplier(abn, accreditedOnly).pipe(
      map(r => r.payload)
    );
  }

  searchSupplier(abn: string, accreditedOnly = false): Observable<PayloadApiResponse<AssetSupplier[]>> {
    console.log('search abn string --------------------------', abn);
    return this.httpClient.post<PayloadApiResponse<AssetSupplier[]>>(URL_SEARCH_ASSET_SUPPLIER_BY_ABN_ACN(abn), {
      accreditedOnly
    }, httpOptions()).pipe();
  }

  getPpsrDocumentsFn = (applicationId: number): Observable<PpsrDocument[]> => {
    return this.getPpsrDocuments(applicationId).pipe(map(r => r.payload));
  }
  getPpsrDocuments(applicationId: number): Observable<PayloadApiResponse<PpsrDocument[]>> {
    return this.httpClient.get<PayloadApiResponse<PpsrDocument[]>>(URL_GET_PPSR_DOCS(applicationId), httpOptions()).pipe();
  }

  getPpsrDetailsFn: AssetSettlementGetPpsrDetailsFn = (applicationId: number) => {
    return this.getPpsrDetails(applicationId).pipe(map(r => r.payload));
  }
  getPpsrDetails(applicationId: number): Observable<PayloadApiResponse<PpsrData | null>> {
    return this.httpClient.get<PayloadApiResponse<PpsrData | null>>(URL_GET_PPSR_DETAILS(applicationId), httpOptions()).pipe();
  }

  getApplicationAssetFn: AssetSettlementGetApplicationAssetFn = (applicationId: number) => {
    return this.getApplicationAsset(applicationId).pipe(map(r => r.payload));
  }
  getApplicationAsset(applicationId: number): Observable<PayloadApiResponse<PpsrAsset[]>> {
    return this.httpClient.get<PayloadApiResponse<PpsrAsset[]>>(URL_GET_APPLICATION_ASSET(applicationId), httpOptions()).pipe();
  }
  updateApplicationAssetsFn = (data: PartialOrNull<PpsrAsset>): Observable<number> => {
    return this.updateApplicationAssets(data).pipe(map(r => r.payload));
  }
  updateApplicationAssets(data: PartialOrNull<PpsrAsset>): Observable<PayloadApiResponse<number>> {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_UPDATE_ASSET(), data, httpOptions()).pipe();
  }

  submitApplicationAssetsFn = (data: PartialOrNull<PpsrAsset>): Observable<number> => {
    return this.submitApplicationAssets(data).pipe(map(r => r.payload));
  }
  submitApplicationAssets(data: PartialOrNull<PpsrAsset>): Observable<PayloadApiResponse<number>> {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_ADD_ASSET(),data, httpOptions());
  }

  searchGrantorsFn = (applicationId: number, data: AssetSearchBody) => {
    return this.searchGrantors(applicationId, data);
  }
  searchGrantors(applicationId: number, data: AssetSearchBody) : Observable<SearchGrantorsResult> {
    return this.httpClient.post(URL_SEARCH_GRANTORS(applicationId), data, httpOptions())
    .pipe(
      map(r => {
        const data:any = r
        if (!data.payload.Error) {
          return {
            status: true,
            message: '',
            payload: data.payload
          }
        }else{
          return {
            status: false,
            message: '',
            payload: data.payload
          }
        }

      })
    );
  }

  saveSupplierFn = (data: SaveSupplierData) => {
    return this.saveSupplier(data);
  }
  saveSupplier(data: SaveSupplierData): Observable<PayloadApiResponse<SaveSupplierResult>> {
    // Returned verbatim: the route answers a duplicate ABN with HTTP 200 and
    // status false, so the caller has to be able to see it.
    return this.httpClient.post<PayloadApiResponse<SaveSupplierResult>>(URL_SAVE_SUPPLIER(), data, httpOptions()).pipe();
  }


  removeApplicationAssetFn: AssetSettlementRemoveApplicationAssetFn = (assetId: number) => {
    return this.removeApplicationAsset(assetId).pipe();
  }
  removeApplicationAsset(assetId: number): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_REMOVE_ASSET(assetId), {}, httpOptions());
  }

}
